export default {"src":"/_next/static/media/US.fc367e29.svg","height":24,"width":36};